import { useContext, useMemo } from 'react';
import { BasketQuote } from '~/lib/types/basket-types';
import { BasketSections } from '~/lib/types/enums';
import { BasketContext } from '~/providers/basketContext';

export function useProtection() {
  const { state } = useContext(BasketContext);

  const protection = useMemo(() => {
    return state.protection;
  }, [state.protection]);

  const quote = useMemo(() => {
    return state.basket.items[state.currentItem]?.sections[BasketSections.QUOTE]?.payload as BasketQuote;
  }, [state.basket.items, state.currentItem]);

  return {
    /** The protection options for the current basket item */
    protection,
    /** The currency of the protection */
    currency: quote?.currency
  };
}
